// extracted by mini-css-extract-plugin
module.exports = {"flex":"Certificates_flex__1EbIR","paragraph":"Certificates_paragraph__1Wugc"};